import {IAuthLevel} from "./ITenantSystem";

export interface IScopeOverview {
    subscopelist: string[],
    scopelist: string[],
}


export enum Popup {
    None,
    Config_AddEdit
}